import { render, staticRenderFns } from "./GeneralInformationForm.vue?vue&type=template&id=48ec3704"
import script from "./GeneralInformationForm.vue?vue&type=script&lang=js"
export * from "./GeneralInformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports